import type { AxiosError } from 'axios';

const retryOnErrorUnauthorized = (failureCount: number, error: AxiosError) => {
  if (error.response?.status === 403) {
    return false;
  }
  return failureCount < 3;
};

const onErrorUnauthorized = (error: AxiosError, fn: () => void) => {
  if (error.response?.status === 403) {
    fn();
  }
};

export { retryOnErrorUnauthorized, onErrorUnauthorized };
